import React from 'react';
import { DateInput, SelectArrayInput, TextInput } from 'react-admin';
import {
    ContainerFieldsList,
    CustomSelectInput,
} from 'candy-commons-components';
import BRANDS from '../../data/ecommerceBrandChoices.json';
import { countryChoices, formatCollectionId } from './form';

const SpecialInitiativesFields = ({
    disabled = false,
    record,
    resource,
    basePath,
}) => (
    <>
        <ContainerFieldsList
            record={record}
            resource={resource}
            basePath={basePath}
        >
            <CustomSelectInput
                source="brand"
                choices={BRANDS}
                disabled={disabled}
            />
            <SelectArrayInput
                source="countries"
                choices={countryChoices}
                translateChoice={false}
                helperText="resources.ecommerce-special-initiatives.countryHelp"
                disabled={disabled}
            />
            <TextInput
                source="collectionId"
                format={formatCollectionId}
                helperText="resources.ecommerce-special-initiatives.collectionHelp"
                disabled={disabled}
            />
        </ContainerFieldsList>
        <ContainerFieldsList
            record={record}
            resource={resource}
            basePath={basePath}
        >
            <DateInput source="validFrom" disabled={disabled} />
            <DateInput source="validTo" disabled={disabled} />
        </ContainerFieldsList>
    </>
);

SpecialInitiativesFields.defaultProps = { fullWidth: true };

export default SpecialInitiativesFields;
